import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faUserGroup,
  faAngleDown,
  faSignOutAlt,
} from "@fortawesome/free-solid-svg-icons";

import { RootState, AppDispatch } from "../../../redux/store";
import { fetchUser, logoutUser } from "../../../redux/userSlice";
import { useModal } from "../../../components/Modal";
import SubscriptionList from "../../savedQueries/SubscriptionList";
import ActionDropdown from "../../../components/dropdown/ActionDropdown";
import ChangeSystemModel from "../Admin/ChangeSystemModel";

export function TopbarUserDropdown() {
  const dispatch = useDispatch<AppDispatch>();
  const { user } = useSelector((state: RootState) => state.user);

  // useEffect(() => {
  //   if (user.firstName === "") {
  //     dispatch(fetchUser());
  //   }
  // }, [dispatch, user.firstName]);

  const openSubscriptionsList = useModal(<SubscriptionList />);
  const openChangeSystemModel = useModal(<ChangeSystemModel />);
  const doLogout = () => {
    dispatch(logoutUser()).then((response) => {
      window.location.href = response.payload;
    });
  };

  return (
    <ActionDropdown
      button={
        <button className="header-top-bar-btn user-dropdown">
          <FontAwesomeIcon icon={faUserGroup} />
          <span>
            {user.firstName} {user.lastName}
          </span>
          <FontAwesomeIcon icon={faAngleDown} />
        </button>
      }
    >
      <aside className="popup">
        <div className="popup-content">
          <div style={{ padding: "12px 16px" }}>
            Welcome, {user.firstName} {user.lastName}
          </div>
        </div>
        <hr></hr>

        <div className="popup-content">
            <div style={{ padding: "12px 16px 0px 16px" }}>
            {user?.corp?.corpName || "Not Selected"}
          </div>
          <div
            className="menu-option"
            role="menuitem"
            tabIndex={0}
            onClick={openChangeSystemModel}
            onKeyDown={(event) => {
              if (event.key === "Enter" || event.key === " ") {
                event.preventDefault();
                openChangeSystemModel();
              }
            }}
          >
            <span >Change System</span>
          </div>
        </div>
        <hr></hr>

        {/* <div className="popup-content">
          <div className="menu-option" onClick={openSubscriptionsList}>
            <span>Subscription Management</span>
          </div>
        </div>
        <hr></hr> */}

        <div className="popup-content">
          <div
            className="menu-option"
            role="menuitem"
            tabIndex={0}
            onClick={doLogout}
            onKeyDown={(event) => {
              if (event.key === "Enter" || event.key === " ") {
                event.preventDefault();
                doLogout();
              }
            }}
          >
            <span>Sign Out</span>
            <FontAwesomeIcon icon={faSignOutAlt} />
          </div>
        </div>
      </aside>
    </ActionDropdown>
  );
}
